import { render } from "./price_list_grid.html?vue&type=template&id=4ddc5ca4&external"
import script from "./price_list_grid.vue?vue&type=script&lang=js"
export * from "./price_list_grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__